<template>
  <div class="main" id="main" style="margin: 0;">
    <div class="wrap">
      <div class="left">
        <div class="title">货运全场景运输管理系统</div>
        <div class="info">重塑运输企业运管能力，助力运输企业持续发展</div>
      </div>
      <div class="right">
        <div class="img"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: 'cockpit',
    };
  },
  methods: {

  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
.main {
  background: url(../assets/img/welcome_bg.jpg) center/cover no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;

  .wrap {
    display: flex;
    justify-content: space-between;
    // align-items: center;

    .left {
      font-family: Source Han Sans CN, Source Han Sans CN;
      color: #444444;

      .title {
        font-weight: bold;
        font-size: 80px;
        height: 136px;
        line-height: 136px;
        margin-top: 260px;
      }

      .info {
        font-weight: 400;
        font-size: 36px;
        height: 64px;
        line-height: 64px;
      }
    }

    .right {
      margin-left: 33px;

      .img {
        width: 535px;
        height: 368px;
        // background: url(../assets/img/welcome_bg_1.png) no-repeat center center/cover;
        overflow: hidden;
      }
    }
  }
}
</style>
